require("packs/filters");
require("packs/bookmarks");
require("packs/link_tracker");
require("packs/original_image");
import "stylesheets/coupons.css";
import { setEvents } from "packs/bookmarks";
import { fetchAPI } from "packs/api";
import { staggerCards } from "packs/card_stagger";
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';

window.Swiper = Swiper;
Swiper.use([Navigation, Pagination, FreeMode]);

document.addEventListener("DOMContentLoaded", () => {
  var loading = false;
  var page = getPageFromURL();
  var lastRequestTime = 0;
  const THROTTLE_DELAY = 500; // 1 second delay between requests
  let requestedPages = new Set();
  
  // Initialize coupon card event delegation (only once)
  initializeDescriptionToggleEventDelegation();
  
  // Initialize share icon event delegation (only once)
  initializeShareEventDelegation();
  
  // Initialize Swiper for Best Coupons section
  initializeBestCouponsSwiper();
  
  // Initialize Swiper for Merchants sections
  initializeMerchantsSwiper();
  
  // Initialize category chip events
  initializeCategoryChips();
  
  // Initialize search dropdown events
  initializeSearchDropdown();
  
  // Initialize tabs functionality
  initializeTabs();
  
  // Initialize exclusive coupons view more functionality
  initializeExclusiveCouponsViewMore();
  
  // Initialize category coupons view more functionality
  initializeCategoryCouponsViewMore();
  function loadMoreContent() {
    const now = Date.now();
    if (
      isElementInViewport(document.getElementById("append_pagination")) && 
      !isFooterVisible() && 
      !loading &&
      !requestedPages.has(page) &&
      now - lastRequestTime > THROTTLE_DELAY
    ) {
      loading = true;
      lastRequestTime = now;
      document.getElementById("pagination-animation").classList.remove("hidden");
      var params = new URLSearchParams(window.location.search);
      var paramsObject = { page: page };
      for (const [key, value] of params) {
        paramsObject[key] = value;
      }
      fetchAPI("/coupons", "GET", paramsObject, "script").then(response => {
        loading = false;
        requestedPages.add(page);
        page += 1;
        document.getElementById("pagination-animation").classList.add("hidden");
        setEvents();
        card_click();
        couponCodeCopy();
        staggerCards('#coupons-list-content');
        // Re-initialize link tracking and coupon click for dynamically loaded content
        if (typeof initLinkTracking === 'function') initLinkTracking();
        if (typeof couponClick === 'function') couponClick();
        setTimeout(recalculateHeight, 100);
      }).catch(error => {
        document.getElementById("pagination-animation").classList.add("hidden");
        loading = false;
      });
    }
  }
  // Throttling scroll event
  let scrollThrottleTimer;
  window.addEventListener("scroll", () => {
    if (scrollThrottleTimer) clearTimeout(scrollThrottleTimer);
    scrollThrottleTimer = setTimeout(loadMoreContent, 100);
  });

  function changeCardView(view) {
    let currentUrl = new URL(window.location.href);
    let displayViewParam = "display_view";
    let displayViewValue = view;
    currentUrl.searchParams.set(displayViewParam, displayViewValue);
    window.location.href = currentUrl;
  }
  document.querySelectorAll(".change-display-view").forEach((display) => {
    display.addEventListener("click", function () {
      changeCardView(this.dataset.view);
    });
  });

  document.querySelectorAll(".change-section").forEach((display) => {
    display.addEventListener("click", function (e) {
      e.preventDefault();
      changeSection(this.dataset.section);
    });
  });

  function changeSection(section) {
    let currentUrl = new URL(window.location.href);
    let sectionParam = "section";
    let sectionValue = section;
    currentUrl.searchParams.set(sectionParam, sectionValue);
    window.location.href = currentUrl;
  }

  function isFooterVisible() {
    let footer = document.getElementById("footer-content");
    let rect = footer.getBoundingClientRect();
    let windowHeight = window.innerHeight || document.documentElement.clientHeight;
  
    let visiblePercentage = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    return visiblePercentage / rect.height >= 0.9;
  }

  function isElementInViewport(el) {
    if (!el || el.style.display === 'none') {
      return false;
    }
    
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function recalculateHeight() {
    document.documentElement.scrollHeight;
  }
});

// Initialize description toggle event delegation
// This function should only be called once on page load
function initializeDescriptionToggleEventDelegation() {
  let toggleDescContent = function (elem, status) {
    if (status == "open") {
      // Find the card container (parent grid element)
      let cardContainer = elem.closest('.card');
      if (cardContainer) {
        // Find the description content within the same card
        let descContent = cardContainer.querySelector('.desc-content');
        if (descContent) {
          // Hide the "Show More" button
          elem.classList.add('hidden');
          // Show the description content
          descContent.classList.remove('hidden');
        }
      }
    } else if (status == "close") {
      // Find the description content container
      let descContent = elem.closest('.desc-content');
      if (descContent) {
        // Find the card container
        let cardContainer = descContent.closest('.card');
        if (cardContainer) {
          // Find and show the "Show More" button again
          let moreInfoButton = cardContainer.querySelector(".desc-open-close");
          if (moreInfoButton) {
            moreInfoButton.classList.remove('hidden');
          }
          // Hide the description content
          descContent.classList.add('hidden');
        }
      }
    }
  };

  // Event delegation for description open buttons
  document.body.addEventListener("click", function(event) {
    const descOpenClose = event.target.closest(".desc-open-close");
    if (descOpenClose) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descOpenClose, "open");
    }
  });

  // Event delegation for description close buttons
  document.body.addEventListener("click", function(event) {
    const descLess = event.target.closest(".desc-less");
    if (descLess) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descLess, "close");
    }
  });
}

// Use event delegation for share icons and close buttons
// This function should only be called once on page load
function initializeShareEventDelegation() {
  // Event delegation for share icons
  document.body.addEventListener("click", function(event) {
    // Check if the clicked element is a shareIcon or inside one
    const shareIcon = event.target.closest(".shareIcon");
    if (shareIcon) {
      event.stopPropagation();
      let popupMenu = shareIcon.nextElementSibling;
      if (popupMenu && popupMenu.classList.contains('popupMenu')) {
        // Close all other open popups first
        document.querySelectorAll('.popupMenu').forEach(function(menu) {
          if (menu !== popupMenu && !menu.classList.contains('hidden')) {
            hideDropdownAnimated(menu);
          }
        });
        // Toggle the current popup
        if (popupMenu.classList.contains('hidden')) {
          showDropdownAnimated(popupMenu);
        } else {
          hideDropdownAnimated(popupMenu);
        }
      }
    }
  });

  // Event delegation for close buttons inside popups
  document.body.addEventListener("click", function(event) {
    const closeDiv = event.target.closest(".closediv");
    if (closeDiv) {
      event.stopPropagation();
      let popupMenu = closeDiv.closest('.popupMenu');
      if (popupMenu) {
        hideDropdownAnimated(popupMenu);
      }
    }
  });

  // Close popups when clicking outside
  document.body.addEventListener("click", function(event) {
    // If click is not on a popup menu or share icon, close all popups
    if (!event.target.closest('.popupMenu') && !event.target.closest('.shareIcon')) {
      document.querySelectorAll('.popupMenu').forEach(function(menu) {
        if (!menu.classList.contains('hidden')) {
          hideDropdownAnimated(menu);
        }
      });
    }
  });
}

function getPageFromURL() {
  let urlParams = new URLSearchParams(window.location.search);
  let pageParam = urlParams.get('page');
  return pageParam ? (parseInt(pageParam, 10) + 1) : 2;
}

function initializeBestCouponsSwiper() {
  const swiperContainer = document.querySelector('.best-coupons-swiper');
  if (!swiperContainer) return;

  // Check if we have coupons to show
  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return;

  const bestCouponsSwiper = new Swiper('.best-coupons-swiper', {
    slidesPerView: 1,
    spaceBetween: 16,
    freeMode: false,
    allowTouchMove: true,
    loop: true,
    centeredSlides: false,
    pagination: {
      el: '.best-coupons-swiper .swiper-pagination',
      clickable: true,
      dynamicBullets: true
    },
    navigation: {
      nextEl: '.best-coupons-swiper .swiper-button-next',
      prevEl: '.best-coupons-swiper .swiper-button-prev',
    },
    breakpoints: {
      // Mobile: 1 slide per view (each slide contains 2 cards vertically stacked)
      320: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        freeMode: false,
        centeredSlides: false
      },
      // Desktop: 1 slide per view (each slide contains 2 cards side by side)
      768: {
        slidesPerView: 1,
        spaceBetween: 16,
        freeMode: false,
        centeredSlides: false
      }
    },
    on: {
      init: function() {
        const slideCount = this.slides.length;
        
        // Hide navigation if there's only one slide or on mobile
        const shouldHideNavigation = slideCount <= 1;
        const isMobile = window.innerWidth < 768; // md breakpoint is 768px
        
        const nextButton = swiperContainer.querySelector('.swiper-button-next');
        const prevButton = swiperContainer.querySelector('.swiper-button-prev');
        const pagination = swiperContainer.querySelector('.swiper-pagination');
        
        if (shouldHideNavigation || isMobile) {
          if (nextButton) nextButton.style.display = 'none';
          if (prevButton) prevButton.style.display = 'none';
          if (pagination) pagination.style.display = 'none';
        } else {
          // Show navigation on desktop only
          if (nextButton) nextButton.style.display = 'block';
          if (prevButton) prevButton.style.display = 'block';
          if (pagination) pagination.style.display = 'block';
        }
      },
      resize: function() {
        const slideCount = this.slides.length;
        const shouldHideNavigation = slideCount <= 1;
        const isMobile = window.innerWidth < 768; // md breakpoint is 768px
        
        const nextButton = swiperContainer.querySelector('.swiper-button-next');
        const prevButton = swiperContainer.querySelector('.swiper-button-prev');
        const pagination = swiperContainer.querySelector('.swiper-pagination');
        
        if (nextButton && prevButton) {
          if (shouldHideNavigation || isMobile) {
            nextButton.style.display = 'none';
            prevButton.style.display = 'none';
            if (pagination) pagination.style.display = 'none';
          } else {
            nextButton.style.display = 'block';
            prevButton.style.display = 'block';
            if (pagination) pagination.style.display = 'block';
          }
        }
      }
    }
  });
}

function initializeMerchantsSwiper() {
  // Initialize Top Merchants Swiper
  const topMerchantsContainer = document.querySelector('.top-merchants-swiper');
  if (topMerchantsContainer) {
    const topMerchantsSlides = topMerchantsContainer.querySelectorAll('.swiper-slide');
    if (topMerchantsSlides.length > 0) {
      const topMerchantsSwiper = new Swiper('.top-merchants-swiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        freeMode: false,
        allowTouchMove: true,
        loop: true,
        centeredSlides: false,
        pagination: {
          el: '.top-merchants-swiper .swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.top-merchants-swiper .swiper-button-next',
          prevEl: '.top-merchants-swiper .swiper-button-prev',
        },
        breakpoints: {
          // Mobile: 1.1 slides per view to show preview of next slide (4 items per slide in 2x2 grid)
          320: {
            slidesPerView: 1.1,
            spaceBetween: 0,
            freeMode: false,
            centeredSlides: false
          },
          // Desktop: 1 slide per view (5 items per slide in horizontal grid)
          768: {
            slidesPerView: 1,
            spaceBetween: 16,
            freeMode: false,
            centeredSlides: false
          }
        },
        on: {
          init: function() {
            const slideCount = this.slides.length;
            const shouldHideNavigation = slideCount <= 1;
            const isMobile = window.innerWidth < 768; // md breakpoint is 768px
            
            const nextButton = topMerchantsContainer.querySelector('.swiper-button-next');
            const prevButton = topMerchantsContainer.querySelector('.swiper-button-prev');
            const pagination = topMerchantsContainer.querySelector('.swiper-pagination');
            
            if (shouldHideNavigation || isMobile) {
              if (nextButton) nextButton.style.display = 'none';
              if (prevButton) prevButton.style.display = 'none';
              if (pagination) pagination.style.display = 'none';
            } else {
              // Show navigation on desktop only
              if (nextButton) nextButton.style.display = 'block';
              if (prevButton) prevButton.style.display = 'block';
              if (pagination) pagination.style.display = 'block';
            }
          },
          resize: function() {
            const slideCount = this.slides.length;
            const shouldHideNavigation = slideCount <= 1;
            const isMobile = window.innerWidth < 768; // md breakpoint is 768px
            
            const nextButton = topMerchantsContainer.querySelector('.swiper-button-next');
            const prevButton = topMerchantsContainer.querySelector('.swiper-button-prev');
            const pagination = topMerchantsContainer.querySelector('.swiper-pagination');
            
            if (nextButton && prevButton) {
              if (shouldHideNavigation || isMobile) {
                nextButton.style.display = 'none';
                prevButton.style.display = 'none';
                if (pagination) pagination.style.display = 'none';
              } else {
                nextButton.style.display = 'block';
                prevButton.style.display = 'block';
                if (pagination) pagination.style.display = 'block';
              }
            }
          }
        }
      });
    }
  }
}

function handleCategoryChipClick(e) {
  e.preventDefault(); // Prevent default link behavior
  
  const chip = e.currentTarget;
  const category = chip.dataset.category || '';
  const url = category ? `/coupons?category=${category}` : '/coupons';
  
  // Update active state immediately for better UX
  const allChips = document.querySelectorAll('.category-chip');
  allChips.forEach(c => {
    c.classList.remove('text-primary', 'border-primary');
    c.classList.add('text-gray-600', 'dark:text-gray-400', 'border-gray-200', 'dark:border-dark-border');
  });
  
  chip.classList.remove('text-gray-600', 'dark:text-gray-400', 'border-gray-200', 'dark:border-dark-border');
  chip.classList.add('text-primary', 'border-primary');
  
  // Add loading state to content
  const content = document.getElementById('category-coupons-content');
  if (content) {
    content.style.opacity = '0.5';
    content.style.pointerEvents = 'none';
  }
  
  // Make AJAX request
  const params = category ? { category: category } : {};
  
  window.fetchAPI('/coupons', 'GET', params, 'script')
    .then(response => {
      // Update URL without page reload
      const newUrl = category ? `/coupons?category=${category}` : '/coupons';
      window.history.pushState({ category: category }, '', newUrl);
      
      // Smooth scroll to category section
      setTimeout(() => {
        const categorySection = document.querySelector('#category-coupons-container');
        if (categorySection) {
          const yOffset = -20; // Offset for spacing
          const y = categorySection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 350);
    })
    .catch(error => {
      console.error('Error loading category coupons:', error);
      // Restore content state on error
      if (content) {
        content.style.opacity = '1';
        content.style.pointerEvents = 'auto';
      }
      // Fall back to full page load
      window.location.href = url;
    });
}

function initializeCategoryChips() {
  const categoryChips = document.querySelectorAll('.category-chip');
  
  categoryChips.forEach(function(chip) {
    chip.addEventListener('click', handleCategoryChipClick);
  });
  
  // Handle browser back/forward buttons (only add once)
  if (!window.categoryPopStateHandlerAdded) {
    window.addEventListener('popstate', function(event) {
      if (event.state && 'category' in event.state) {
        location.reload(); // Reload on back/forward for simplicity
      }
    });
    window.categoryPopStateHandlerAdded = true;
  }
}

// Helper function to re-initialize chips on new content
window.initializeCategoryChipsOnNewContent = function(chips) {
  chips.forEach(function(chip) {
    chip.addEventListener('click', handleCategoryChipClick);
  });
}

function restoreScrollPosition() {
  const savedScrollPosition = localStorage.getItem('couponsPageScrollPosition');
  const savedTimestamp = localStorage.getItem('couponsPageScrollTimestamp');
  
  if (savedScrollPosition && savedTimestamp) {
    // Only restore if the scroll position was saved recently (within 30 seconds)
    const timeDiff = Date.now() - parseInt(savedTimestamp, 10);
    if (timeDiff > 30000) { // 30 seconds
      localStorage.removeItem('couponsPageScrollPosition');
      localStorage.removeItem('couponsPageScrollTimestamp');
      return;
    }
    
    const targetPosition = parseInt(savedScrollPosition, 10);
    
    // Function to scroll to the saved position
    const scrollToPosition = () => {
      window.scrollTo({
        top: targetPosition,
        behavior: 'instant' // Instant scroll without animation
      });
    };
    
    // Function to check if we need to retry scrolling
    const checkAndScroll = () => {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(currentPosition - targetPosition) > 10) {
        scrollToPosition();
        // Retry after a short delay if still not at the right position
        setTimeout(() => {
          const newPosition = window.pageYOffset || document.documentElement.scrollTop;
          if (Math.abs(newPosition - targetPosition) > 10) {
            scrollToPosition();
          }
        }, 100);
      }
    };
    
    // Try multiple approaches to ensure scroll restoration works
    if (document.readyState === 'complete') {
      requestAnimationFrame(scrollToPosition);
      setTimeout(checkAndScroll, 50);
    } else {
      window.addEventListener('load', () => {
        requestAnimationFrame(scrollToPosition);
        setTimeout(checkAndScroll, 50);
      });
    }
    
    // Also try after a short delay as a fallback
    setTimeout(scrollToPosition, 100);
    
    // Clear the saved position after restoring
    localStorage.removeItem('couponsPageScrollPosition');
    localStorage.removeItem('couponsPageScrollTimestamp');
  }
}

function initializeSearchDropdown() {
  const searchBox = document.getElementById('search-box-coupons');
  const searchDropdown = document.getElementById('search-dropdown');
  const clearButton = document.getElementById('clear-search-btn');
  
  if (!searchBox || !searchDropdown) return;
  
  let searchTimeout;
  let currentSearchTerm = '';
  let isLoading = false;
  
  // Show dropdown when search box is clicked or focused (only if there's content)
  searchBox.addEventListener('click', function(e) {
    e.stopPropagation();
    if (searchBox.value.trim()) {
      updateSearchBoxStyle(true);
      performSearch(searchBox.value.trim());
      showSearchDropdown();
    }
  });
  
  searchBox.addEventListener('focus', function(e) {
    e.stopPropagation();
    if (searchBox.value.trim()) {
      updateSearchBoxStyle(true);
      performSearch(searchBox.value.trim());
      showSearchDropdown();
    }
  });
  
  // Handle search input with debouncing
  searchBox.addEventListener('input', function(e) {
    const searchTerm = e.target.value.trim();
    
    // Update clear button visibility
    updateClearButtonVisibility(searchTerm.length > 0);
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // If search term is empty, hide dropdown
    if (!searchTerm) {
      updateSearchBoxStyle(false);
      hideSearchDropdown();
      return;
    }
    
    // Show dropdown and update style when user starts typing
    updateSearchBoxStyle(true);
    showSearchDropdown();
    
    // Debounce the search to avoid too many API calls
    searchTimeout = setTimeout(() => {
      if (searchTerm !== currentSearchTerm) {
        performSearch(searchTerm);
      }
    }, 300); // 300ms delay
  });
  
  // Handle keyboard navigation
  let selectedIndex = -1;
  
  searchBox.addEventListener('keydown', function(e) {
    const searchItems = searchDropdown.querySelectorAll('[data-search-item]');
    
    switch(e.key) {
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && searchItems[selectedIndex]) {
          const selectedItem = searchItems[selectedIndex];
          const name = selectedItem.getAttribute('data-name');
          const url = selectedItem.getAttribute('data-url');
          const type = selectedItem.getAttribute('data-type');
          handleSearchSelection(name, url, type);
        } else {
          const searchTerm = searchBox.value.trim();
          if (searchTerm) {
            handleSearchSelection(searchTerm, null);
          }
        }
        break;
        
      case 'ArrowDown':
        e.preventDefault();
        if (searchItems.length > 0) {
          selectedIndex = Math.min(selectedIndex + 1, searchItems.length - 1);
          updateSelectedItem(searchItems);
        }
        break;
        
      case 'ArrowUp':
        e.preventDefault();
        if (searchItems.length > 0) {
          selectedIndex = Math.max(selectedIndex - 1, -1);
          updateSelectedItem(searchItems);
        }
        break;
        
      case 'Escape':
        e.preventDefault();
        updateSearchBoxStyle(false);
        hideSearchDropdown();
        selectedIndex = -1;
        break;
    }
  });
  
  function updateSelectedItem(searchItems) {
    // Remove previous selection
    searchItems.forEach(item => {
      item.classList.remove('bg-background-shade-light', 'dark:bg-background-shade-dark');
    });
    
    // Add selection to current item
    if (selectedIndex >= 0 && searchItems[selectedIndex]) {
      searchItems[selectedIndex].classList.add('bg-background-shade-light', 'dark:bg-background-shade-dark');
      searchItems[selectedIndex].scrollIntoView({ block: 'nearest' });
    }
  }
  
  // Hide dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!searchBox.contains(e.target) && !searchDropdown.contains(e.target)) {
      updateSearchBoxStyle(false);
      hideSearchDropdown();
      selectedIndex = -1;
    }
  });
  
  // Clear button functionality
  if (clearButton) {
    clearButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      clearSearch();
    });
  }
  
  function updateClearButtonVisibility(show) {
    if (clearButton) {
      if (show) {
        clearButton.classList.remove('hidden');
      } else {
        clearButton.classList.add('hidden');
      }
    }
  }
  
  function clearSearch() {
    searchBox.value = '';
    updateClearButtonVisibility(false);
    updateSearchBoxStyle(false);
    hideSearchDropdown();
    selectedIndex = -1;
    currentSearchTerm = '';
    
    // Clear any pending search timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
  }
  
  function updateSearchBoxStyle(isOpen) {
    if (isOpen) {
      searchBox.classList.remove('rounded-bradius10');
      searchBox.classList.add('rounded-t-bradius10');
      searchBox.classList.remove('rounded-b-bradius10');
    } else {
      searchBox.classList.remove('rounded-t-bradius10');
      searchBox.classList.add('rounded-bradius10');
      searchBox.classList.add('rounded-b-bradius10');
    }
  }
  
  function performSearch(searchTerm) {
    if (isLoading || searchTerm === currentSearchTerm) return;
    
    currentSearchTerm = searchTerm;
    isLoading = true;
    
    showLoadingState();
    
    // Make API call to merchant_group_lookup
    fetchAPI('/merchant_group_lookup', 'GET', { q: searchTerm }, 'json')
      .then(data => {
        isLoading = false;
        displaySearchResults(data);
      })
      .catch(error => {
        isLoading = false;
        console.error('Search error:', error);
        showErrorState();
      });
  }
  
  function showLoadingState() {
    const dropdownContent = searchDropdown.querySelector('div > div');
    if (dropdownContent) {
      dropdownContent.innerHTML = `
        <div class="p-4 text-center">
          <div class="inline-flex items-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="text-secondary-text-light dark:text-secondary-text-dark">${I18n.t("searching")}</span>
          </div>
        </div>
      `;
    }
    showSearchDropdown();
  }
  
  function showErrorState() {
    const dropdownContent = searchDropdown.querySelector('div > div');
    if (dropdownContent) {
      dropdownContent.innerHTML = `
        <div class="p-4 text-center">
          <div class="flex flex-col items-center">
            <svg class="w-8 h-8 text-red-500 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
            <span class="text-red-500 text-sm">Search failed. Please check your connection and try again.</span>
          </div>
        </div>
      `;
      
      // Add retry functionality
      const retryButton = document.createElement('button');
      retryButton.className = 'mt-2 text-xs text-primary hover:underline';
      retryButton.textContent = 'Retry';
      retryButton.addEventListener('click', function() {
        if (currentSearchTerm) {
          performSearch(currentSearchTerm);
        }
      });
      
      const errorContainer = dropdownContent.querySelector('.flex.flex-col.items-center');
      if (errorContainer) {
        errorContainer.appendChild(retryButton);
      }
    }
  }
  
  function displaySearchResults(data) {
    const dropdownContent = searchDropdown.querySelector('div > div');
    if (!dropdownContent) return;
    
    let html = '';
    
    // Helper function to escape HTML
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    // Display merchants if any
    if (data.merchants && data.merchants.length > 0) {
      html += `
        <div class="p-4 border-b border-b-light-border dark:border-b-dark-border">
          <div class="text-sm font-medium text-secondary-text-light dark:text-secondary-text-dark mb-2">Stores</div>
          <div class="space-y-1">
      `;
      
      data.merchants.forEach(merchant => {
        const escapedName = escapeHtml(merchant.name);
        const escapedUrl = escapeHtml(merchant.url);
        const escapedImageUrl = escapeHtml(merchant.image_url);
        
        html += `
          <div class="flex items-center p-2 rounded-lg hover:bg-background-shade-light dark:hover:bg-background-shade-dark cursor-pointer transition-colors duration-150" 
               data-search-item data-type="merchant" data-url="${escapedUrl}" data-name="${escapedName}">
            <div class="border border-light-border dark:border-dark-border w-[60px] h-[40px] rounded mr-3 bg-white dark:bg-white flex items-center justify-center overflow-hidden">
              <img src="${escapedImageUrl}" alt="${escapedName}" class="max-w-full max-h-full object-contain" onerror="this.style.display='none'">
            </div>
            <div class="flex-1">
              <span class="text-primary-text-light dark:text-primary-text-dark text-sm font-medium">${escapedName}</span>
              <div class="text-xs text-secondary-text-light dark:text-secondary-text-dark">${merchant.active_coupons_count || 0} active coupons</div>
            </div>
          </div>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    }
    
    // Display groups/categories if any
    if (data.groups && data.groups.length > 0) {
      html += `
        <div class="p-4 ${data.merchants && data.merchants.length > 0 ? 'border-b border-b-light-border dark:border-b-dark-border' : ''}">
          <div class="text-sm font-medium text-secondary-text-light dark:text-secondary-text-dark mb-2">Categories</div>
          <div class="space-y-1">
      `;
      
      data.groups.forEach(group => {
        const escapedName = escapeHtml(group.name);
        const escapedUrl = escapeHtml(group.url);
        const escapedImageUrl = escapeHtml(group.image_url);
        
        html += `
          <div class="flex items-center p-2 rounded-lg hover:bg-background-shade-light dark:hover:bg-background-shade-dark cursor-pointer transition-colors duration-150" 
               data-search-item data-type="group" data-url="${escapedUrl}" data-name="${escapedName}">
            <div class="border border-light-border dark:border-dark-border w-[50px] h-[50px] rounded-full mr-3 bg-white dark:bg-white flex items-center justify-center overflow-hidden">
              <img src="${escapedImageUrl}" alt="${escapedName}" class="w-full h-full object-cover" onerror="this.style.display='none'">
            </div>
            <span class="text-primary-text-light dark:text-primary-text-dark text-sm">${escapedName}</span>
          </div>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    }
    
    // Show no results message if nothing found
    if ((!data.merchants || data.merchants.length === 0) && (!data.groups || data.groups.length === 0)) {
      html = `
        <div class="p-4 text-center">
          <span class="text-secondary-text-light dark:text-secondary-text-dark text-sm">
            ${I18n.t("no_stores_or_categories_found", { search_term: escapeHtml(currentSearchTerm) })}
          </span>
        </div>
      `;
    }
    
    dropdownContent.innerHTML = html;
    
    // Reset selected index when new results are displayed
    selectedIndex = -1;
    
    // Add click event listeners to search items
    const searchItems = dropdownContent.querySelectorAll('[data-search-item]');
    searchItems.forEach(item => {
      item.addEventListener('click', function() {
        const name = this.getAttribute('data-name');
        const url = this.getAttribute('data-url');
        const type = this.getAttribute('data-type');
        handleSearchSelection(name, url, type);
      });
    });
  }
  
  
  function handleSearchSelection(name, url, type) {
    searchBox.value = name;
    updateClearButtonVisibility(name.length > 0);
    updateSearchBoxStyle(false);
    hideSearchDropdown();
    selectedIndex = -1;
    
    if (url) {
      // Navigate to the selected store or category
      window.location.href = url;
    } else {
      // If no URL provided, perform a general search
      console.log('Performing general search for:', name);
      // You can implement general search functionality here
    }
  }
  
  function showSearchDropdown() {
    searchDropdown.classList.remove('hidden');
    // Use requestAnimationFrame to ensure the element is rendered before applying animation
    requestAnimationFrame(() => {
      searchDropdown.classList.remove('opacity-0', 'translate-y-[-10px]');
      searchDropdown.classList.add('opacity-100', 'translate-y-0');
    });
  }
  
  function hideSearchDropdown() {
    searchDropdown.classList.remove('opacity-100', 'translate-y-0');
    searchDropdown.classList.add('opacity-0', 'translate-y-[-10px]');
    // Hide the element after animation completes
    setTimeout(() => {
      if (searchDropdown.classList.contains('opacity-0')) {
        searchDropdown.classList.add('hidden');
      }
    }, 200); // Matches the duration-200 class
  }
  
  // Initialize clear button visibility based on current search box value
  updateClearButtonVisibility(searchBox.value.trim().length > 0);
}

function initializeTabs() {
  // Get all tab buttons and panels
  const tabButtons = document.querySelectorAll('[role="tab"]');
  const tabPanels = document.querySelectorAll('[role="tabpanel"]');
  
  if (tabButtons.length === 0 || tabPanels.length === 0) return;
  
  // Add click event listeners to all tab buttons
  tabButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const targetPanelId = this.getAttribute('data-tab-target');
      const targetPanel = document.getElementById(targetPanelId);
      
      if (!targetPanel) return;
      
      // Remove active state from all tabs
      tabButtons.forEach(function(btn) {
        btn.setAttribute('aria-selected', 'false');
        btn.classList.remove('tab-active', 'text-primary', 'border-primary');
        btn.classList.add('tab', 'text-gray-500', 'dark:text-gray-300', 'border-transparent');
      });
      
      // Hide all panels
      tabPanels.forEach(function(panel) {
        panel.classList.remove('block');
        panel.classList.add('hidden');
      });
      
      // Activate clicked tab
      this.setAttribute('aria-selected', 'true');
      this.classList.remove('tab', 'text-gray-500', 'dark:text-gray-300', 'border-transparent');
      this.classList.add('tab-active', 'text-primary', 'border-primary');
      
      // Show target panel with animation
      targetPanel.classList.remove('hidden');
      targetPanel.classList.add('block', 'tab-panel-animate');
      targetPanel.addEventListener('animationend', function handler() {
        targetPanel.classList.remove('tab-panel-animate');
        targetPanel.removeEventListener('animationend', handler);
      });
    });
    
    // Add keyboard navigation support
    button.addEventListener('keydown', function(e) {
      const currentIndex = Array.from(tabButtons).indexOf(this);
      let nextIndex;
      
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          nextIndex = currentIndex > 0 ? currentIndex - 1 : tabButtons.length - 1;
          tabButtons[nextIndex].click();
          tabButtons[nextIndex].focus();
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextIndex = currentIndex < tabButtons.length - 1 ? currentIndex + 1 : 0;
          tabButtons[nextIndex].click();
          tabButtons[nextIndex].focus();
          break;
        case 'Home':
          e.preventDefault();
          tabButtons[0].click();
          tabButtons[0].focus();
          break;
        case 'End':
          e.preventDefault();
          tabButtons[tabButtons.length - 1].click();
          tabButtons[tabButtons.length - 1].focus();
          break;
      }
    });
  });
}

function initializeExclusiveCouponsViewMore() {
  const viewMoreButton = document.getElementById('view-more-exclusive-button');
  const additionalCoupons = document.getElementById('additional-exclusive-coupons');
  
  if (!viewMoreButton || !additionalCoupons) return;
  
  const button = viewMoreButton.querySelector('button');
  if (!button) return;
  
  // Remove any existing listeners by cloning the button
  const newButton = button.cloneNode(true);
  button.parentNode.replaceChild(newButton, button);
  
  newButton.addEventListener('click', function() {
    additionalCoupons.classList.remove('hidden');
    viewMoreButton.classList.add('hidden');
    // Event delegation handles all coupon card interactions automatically
  });
}

function initializeCategoryCouponsViewMore() {
  const viewMoreButton = document.getElementById('view-more-category-button');
  const additionalCoupons = document.getElementById('additional-category-coupons');
  
  if (!viewMoreButton || !additionalCoupons) return;
  
  const button = viewMoreButton.querySelector('button');
  if (!button) return;
  
  // Remove any existing listeners by cloning the button
  const newButton = button.cloneNode(true);
  button.parentNode.replaceChild(newButton, button);
  
  newButton.addEventListener('click', function() {
    additionalCoupons.classList.remove('hidden');
    viewMoreButton.classList.add('hidden');
    // Event delegation handles all coupon card interactions automatically
  });
}

// Expose functions globally for use in AJAX responses
window.initializeExclusiveCouponsViewMore = initializeExclusiveCouponsViewMore;
window.initializeCategoryCouponsViewMore = initializeCategoryCouponsViewMore;